// Breekpunten van de app. DIT IS DE ENIGE PLEK waar deze getallen staan.
//
// LET OP — DE CSS-KANT
// --------------------
// Een CSS custom property werkt niet in een @media-conditie: `@media (max-width: var(--x))`
// is ongeldig. Een gedeeld token tussen JS en CSS is dus onmogelijk. Daarom zet AppShell de
// drawer-modus als een KLASSE op .app-shell (`app-shell--narrow`) en schakelt shell.css op
// die klasse in plaats van op een media query. Zo staat het getal maar één keer in de
// codebase en kunnen JS en CSS niet uit elkaar lopen.

// GEDEELDE BREEKPUNTSCHAAL (fundament UX-herwerking)
// ---------------------------------------------------
// Drie treden voor de hele app. Nieuwe schermen gebruiken UITSLUITEND deze drie; de losse
// 640/760/768/899/1100 in features worden per scherm hierop gezet.
//   PHONE   onder deze breedte = gsm-layout (kaarten i.p.v. tabellen, KPI's in 2 kolommen,
//           drawers fullscreen). In CSS: @media (max-width: 639.98px).
//   TABLET  onder deze breedte = compacte desktoplayout. In CSS: @media (max-width: 1023.98px).
//   DRAWER  onder deze breedte schuift de zijbalk weg (= DRAWER_BREAKPOINT hieronder).
export const PHONE = 640;
export const TABLET = 1024;
export const DRAWER = 1600;

// Liquiditeit (cashflowForecast) rendert onder 900px zijn eigen telefoonlayout. Dat getal
// blijft tot die pagina in zijn eigen fase op PHONE wordt gezet; tot dan staat het HIER en
// niet meer los in de hook.
export const LIQUIDITEIT_PHONE = 900;

// Onder deze breedte schuift de zijbalk weg achter een hamburgerknop.
// Stond op 1400 (een 13" MacBook Air is 1280px breed en zat daar dus onder). Bewust ruimer
// gezet zodat de zijbalk eerder wegschuift en er meer plek overblijft voor de inhoud.
// LET OP: een geschaald 5K-scherm ("UI looks like 2560x1440") is ~2560px breed en zit hier
// dus bóven — daar blijft de zijbalk bij een maximaal venster gewoon staan.
export const DRAWER_BREAKPOINT = DRAWER;

// Assets: onder deze breedte vallen de secundaire kolommen weg (ze blijven bewerkbaar in
// het detailpaneel per rij). In de weergave "alles" staan er veel meer kolommen naast
// elkaar, dus daar ligt de drempel hoger.
export const ASSETS_COMPACT = 1180;
export const ASSETS_COMPACT_ALLES = 1500;
